import { Match, ParentProps, Show, Switch, createEffect, createMemo } from "solid-js";
import { GroupDef, requireSelectContext } from "../SelectContext";
import Flexbox from "../../st-flexbox/st-flexbox";
import styles from '../st-select.module.css';

export function SelectItem<T extends string | any = string>(props: ParentProps<{ value?: T; label?: string; separator?: boolean }>) {
    const ctx = requireSelectContext();

    const displayValue = createMemo(() => props.label ?? props.children ?? props.value?.toString());
    const selected = createMemo(() => ctx.value() == props.value?.toString());

    createEffect(() => {
        if (props.value === ctx.value()) {
            ctx.setDefaultDisplayValue(<>{props.label ?? props.children ?? props.value?.toString() ?? ''}</>);
        }
    })

    function Item() {

        function onClick() {
            ctx.setValue(props.value?.toString() ?? '');
            ctx.setOpen(false);
        }

        return <Switch>
            <Match when={props.separator}>
                <Flexbox as="li" dir="horizontal" middle role="presentation" class={styles.separator} style={{ "user-select": "none" }}>
                    <Flexbox.Item auto></Flexbox.Item>
                </Flexbox>
            </Match>
            <Match when={!props.separator}>
                <Flexbox as="li" dir="horizontal" middle role="button" onClick={onClick} data-selected={selected()} style={{ "user-select": "none" }}>
                    <span>
                        <Show when={!displayValue()}>&nbsp;</Show>
                        {displayValue()}
                    </span>
                </Flexbox>
            </Match>
        </Switch>
    }

    if (ctx.groups().length == 0) {
        ctx.setGroups([new GroupDef('')]);
    }
    const groupDef = ctx.groups()[ctx.groups().length - 1];
    groupDef.items.push(<Item />);

    return <></>
}
